import { createContext, useContext } from 'react';

export type StepperContextT = {
  steps: number;
} | null;

export const StepperContext = createContext<StepperContextT>(null);

export function useStepperContext(): NonNullable<StepperContextT> {
  const context = useContext(StepperContext);

  if (context === null) throw new Error('Components must be wrapped in <Stepper />');

  return context;
}
